import { ErrorPage } from "@branding/ui";

export function NotFoundPage() {
  return <ErrorPage code={404} actionHref="/pasar" />;
}
